import type { CommonEditorTab } from "./reducers";
import { mdiFileMultipleOutline } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { NavbarTabButton } from "../shell/NavbarTabButton";

type Props = {
  disabled?: boolean;
};

export function NavbarPagesTabButton({ disabled }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabButton
      tooltip={t("NavbarPagesTabButton.tooltip")}
      value={"pages" satisfies CommonEditorTab}
      iconPath={mdiFileMultipleOutline}
      disabled={disabled}
    />
  );
}
